/**
 * Command Center Color Palette
 * Professional light theme colors for counterterrorism intelligence dashboard
 */

const COMMAND_CENTER_COLORS = {
  // Base Background Colors
  background: {
    primary: '#f8fafc',      // Main dashboard background
    secondary: '#ffffff',     // Card backgrounds
    accent: '#f1f5f9',       // Section headers
    elevated: '#fafbfc',     // Elevated surfaces
  },

  // Alert Level Colors
  alerts: {
    critical: {
      bg: '#fef2f2',           // Very light red background
      border: '#ef4444',       // Vibrant red border
      text: '#991b1b',         // Dark red text
      glow: 'rgba(239, 68, 68, 0.15)',  // Red glow effect
      pulse: '#dc2626',        // Pulse animation color
    },
    high: {
      bg: '#fff7ed',           // Very light orange
      border: '#f97316',       // Vibrant orange
      text: '#9a3412',         // Dark orange
      glow: 'rgba(249, 115, 22, 0.12)',
      pulse: '#ea580c',
    },
    elevated: {
      bg: '#fefce8',           // Very light yellow
      border: '#eab308',       // Vibrant yellow
      text: '#854d0e',         // Dark yellow
      glow: 'rgba(234, 179, 8, 0.1)',
      pulse: '#ca8a04',
    },
  },

  // Threat Level Colors (Map Markers & Charts)
  threat: {
    critical: '#dc2626',       // Red
    high: '#f97316',           // Orange
    medium: '#eab308',         // Yellow/Amber
    low: '#10b981',            // Green
    unknown: '#64748b',        // Gray
  },

  // Intelligence Feed
  feed: {
    cardBg: '#ffffff',
    cardHover: '#f8fafc',
    borderDefault: '#e2e8f0',
    borderHover: '#cbd5e1',
    textPrimary: '#0f172a',    // Dark slate
    textSecondary: '#64748b',  // Medium slate
    badge: '#0085E5',          // Primary blue
  },

  // Map Elements
  map: {
    markerShadow: 'rgba(0, 0, 0, 0.25)',
    clusterBg: '#0085E5',
    clusterText: '#ffffff',
    popupBg: '#ffffff',
    popupBorder: '#e2e8f0',
  },

  // Typography
  text: {
    primary: '#0f172a',        // Very dark slate (headings)
    secondary: '#475569',      // Medium slate (body)
    tertiary: '#64748b',       // Light slate (labels)
    muted: '#94a3b8',         // Very light slate (hints)
    inverse: '#ffffff',        // White (on dark backgrounds)
  },

  // Accent & Interactive
  accent: {
    primary: '#0085E5',        // Existing primary blue
    primaryHover: '#0074cc',   // Darker blue
    cyan: '#06b6d4',           // Cyan for highlights
    success: '#10b981',        // Green
    warning: '#f59e0b',        // Amber
    danger: '#ef4444',         // Red
  },

  // Chart Colors (Professional & Distinct)
  charts: {
    series1: '#0085E5',        // Blue
    series2: '#06b6d4',        // Cyan
    series3: '#8b5cf6',        // Violet
    series4: '#ec4899',        // Pink
    series5: '#f59e0b',        // Amber
    grid: '#f1f5f9',           // Very light gray
    axisLabels: '#94a3b8',     // Light slate
  },

  // Borders & Dividers
  borders: {
    light: '#f0f1f3',
    default: '#e2e8f0',
    medium: '#cbd5e1',
    dark: '#94a3b8',
  },

  // Shadows (Intelligence-grade elevation hierarchy)
  shadows: {
    level1: '0 2px 4px rgba(0,0,0,0.08), 0 8px 20px rgba(0,0,0,0.12)',  // Command Status Bar (most prominent)
    level2: '0 1px 3px rgba(0,0,0,0.06), 0 6px 16px rgba(0,0,0,0.08)',  // Geographic Intelligence (primary focus)
    card: '0 1px 3px rgba(0,0,0,0.05), 0 4px 14px rgba(0,0,0,0.06)',     // Standard cards
    cardHover: '0 2px 8px rgba(0,0,0,0.08), 0 8px 24px rgba(0,0,0,0.1)', // Hover state
    elevated: '0 4px 6px rgba(0,0,0,0.07), 0 10px 20px rgba(0,0,0,0.08)', // Elevated surfaces
    alert: '0 4px 12px rgba(239, 68, 68, 0.2)',  // Red shadow for critical alerts
  },
};

export default COMMAND_CENTER_COLORS;
